type StatisticProps = {
  testid: string;
  label: string;
  value: string | number;
};

export function Statistic(props: StatisticProps) {
  const { testid, label, value } = props;

  return (
    <div data-testid={testid}>
      <div data-testid={`${testid}-value`} className="text-2xl">
        {value}
      </div>
      <div data-testid={`${testid}-label`}>{label}</div>
    </div>
  );
}
